import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const caregiverKeys = createQueryKeys("caregiver", {
  search: (term: string) => ({ term }),
  list: null,
});
